"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
class PredicateRangeValue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditingIndexText: null,
        };
    }
    render() {
        const { device, values, handleValueUpdate } = this.props;
        const { Fragment } = React;
        return (React.createElement(Fragment, null,
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: device === 'Mobile' ? 96 : 80,
                    borderBottom: `1px solid ${index_1.titanium}`,
                }, onClick: () => this.setState({
                    isEditingIndexText: 0,
                }) },
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        padding: device === 'Mobile' ? '22px 0' : '14px 0',
                    } },
                    React.createElement(index_1.Text, { label: true, text: "Min", size: "medium" }),
                    React.createElement(index_1.Text, { text: values[0] == null ? '' : values[0], textStyle: {
                            width: device === 'Mobile' ? 'calc(100vw - 48px)' : 350,
                        }, placeholder: true, placeholderText: "Value", size: "medium", id: `predicate-range-value-min-input`, contentEditable: this.state.isEditingIndexText === 0, onInputChange: (str) => {
                            let newValues = [...values];
                            newValues[0] = str.length === 0 ? null : str;
                            handleValueUpdate(newValues);
                        }, handleChange: (str) => {
                            this.setState({
                                isEditingIndexText: null,
                            });
                        } }))),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: device === 'Mobile' ? 96 : 80,
                    borderBottom: `1px solid ${index_1.titanium}`,
                }, onClick: () => this.setState({
                    isEditingIndexText: 1,
                }) },
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        padding: device === 'Mobile' ? '22px 0' : '14px 0',
                    } },
                    React.createElement(index_1.Text, { label: true, text: "Max", size: "medium" }),
                    React.createElement(index_1.Text, { text: values[1] == null ? '' : values[1], textStyle: {
                            width: device === 'Mobile' ? 'calc(100vw - 48px)' : 350,
                        }, placeholder: true, placeholderText: "Value", size: "medium", id: `predicate-range-value-max-input`, contentEditable: this.state.isEditingIndexText === 1, onInputChange: (str) => {
                            let newValues = [...values];
                            newValues[1] = str.length === 0 ? null : str;
                            handleValueUpdate(newValues);
                        }, handleChange: (str) => {
                            this.setState({
                                isEditingIndexText: null,
                            });
                        } })))));
    }
}
PredicateRangeValue.defaultProps = {
    values: [null, null],
};
exports.default = PredicateRangeValue;
